<form [formGroup]="newSiteForm">
  <div class="form-step-container">
    <div class="form-step-title">ENTER YOUR PROPERTY LOCATION</div>

    <div class="input-label">There are several ways to locate your property. Choose from drop down list below:</div>

    <div class="select-container">
      <div class="main-cell1">
        <div class="input-label">Location</div>
        <mat-form-field class="full-width">
          <mat-select formControlName="locationType" placeholder="Select a location type" required>
            <mat-option *ngFor="let type of locationTypes" [value]="type.value">
              {{ type.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="validation-error" *ngIf="locationType.invalid && (locationType.dirty || locationType.touched)">
          <div *ngIf="locationType.errors.required">Location type is required.</div>
        </div>

        <div [hidden]="!(newSiteForm && locationType.value === 'address')">
          <div class="input-label">Enter Address</div>
          <div class="forward-location-container form" data-cy="forward-location-container"></div>
        </div>
        <div [hidden]="!(newSiteForm && locationType.value === 'coordinates')">
          <div class="input-label">Enter Lat/Long Coordinates</div>
          <div class="reverse-location-container form"></div>
        </div>
        <div [hidden]="!(newSiteForm && locationType.value === 'parcelId')">
          <div class="input-label">Enter Parcel Number</div>
          <mat-form-field class="full-width">
            <input
              matInput
              type="text"
              placeholder="##-##..."
              aria-label="parcel id"
              [matAutocomplete]="auto"
              data-cy="parcel-autocomplete-input"
              [formControl]="newSiteForm.get('parcelNumber')" />
          </mat-form-field>
          <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption [displayWith]="displayFn">
            <mat-option *ngIf="isLoading" class="is-loading">Loading...</mat-option>
            <ng-container *ngIf="!isLoading && filteredParcelNumbers?.length === 0">
              <mat-option [disabled]="true" class="is-loading">No Parcels found</mat-option>
            </ng-container>
            <ng-container *ngIf="!isLoading">
              <mat-option
                *ngFor="let item of filteredParcelNumbers"
                data-cy="parcel-autocomplete-option"
                [value]="item">
                <span>{{ item.parcelNumber }} - {{ item.county }}</span>
              </mat-option>
            </ng-container>
          </mat-autocomplete>
        </div>
        <div class="validation-error" *ngIf="geocoderTouched && disableNext">
          Please choose your location from the results list.
        </div>

        <div class="step-button-container">
          <button mat-stroked-button color="primary" (click)="goBack()">Back</button>
          <button
            mat-raised-button
            color="primary"
            type="button"
            [disabled]="disableNext"
            (click)="checkRegionAndProceed()"
            data-cy="next2-button">
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
